// extracted by mini-css-extract-plugin
export default {"root":"_3k150","menu-item":"Aq6Wc","menuItem":"Aq6Wc","selected":"_4gL_Q"};